import { render } from "./SearchFilterNew.vue?vue&type=template&id=2376ce7c&scoped=true"
import script from "./SearchFilterNew.vue?vue&type=script&lang=js"
export * from "./SearchFilterNew.vue?vue&type=script&lang=js"

import "./SearchFilterNew.vue?vue&type=style&index=0&id=2376ce7c&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2376ce7c"]])

export default __exports__